// src/app/core/local-state-version.ts

const APP_VERSION = '2025-12-11-explore-reset-v1';

export function initLocalStateVersion() {
  try {
    const stored = localStorage.getItem('challup_app_version');
    if (stored !== APP_VERSION) {
      const keysToClear = [
        'explore_sticky_active',
        'explore_sticky_day',
        'feedAccess',
        'justCompletedChallenge',
        'justCompletedChallenge_day',
        'justCompletedChallenge_expiry',
        // 👉 aquí puedes añadir más claves si recuerdas otras
      ];

      keysToClear.forEach((k) => localStorage.removeItem(k));

      localStorage.setItem('challup_app_version', APP_VERSION);
    }
  } catch {
    // Si localStorage no está disponible, simplemente no hacemos nada
  }
}
